export default {
  welcome: {
    greetings: `Hello! {br}
    We're excited to welcome you! {br}
    We've started preparing for your onboarding in the company :) {br}
    Right now two sections of the questionnaire are of particular importance for us: {contactDetails} and {organizationalMatters}. {br}
    Please fill these out {dueDate}. {br}
    Thank you!`,
    by: 'by',
    on: 'on',
    contactDetails: 'contact details',
    organizationalMatters: 'organizational matters',
  },
  finished: {
    title: `Your registration is complete.{0}Welcome to\xa0the\xa0company!`,
  },
  willNotSaved: 'File will not be saved',
  updating: {
    title: 'Under maintenance',
    broken: 'Someone broke our website!',
    underMaintenance: "Just kidding! It's under maintenance.",
    tryLater: 'Try {0} later.',
    refreshPage: 'refreshing the page',
  },
};
